<template>
    <base-tippy
        class="mx-0.5 self-center"
        placement="bottom-end"
    >
        <base-icon
            class="text-red-600"
            icon="exclamation-circle"
            size="sm"
        ></base-icon>
        <template #content>
            <div class="px-4">
                <span>Erreurs :</span>
                <ul class="list-none">
                    <li
                        v-for="(error, index) of errors"
                        :key="index"
                        v-text="error"
                    ></li>
                </ul>
            </div>
        </template>
    </base-tippy>
</template>

<script>
import BaseIcon from '../Base/BaseIcon'
import BaseTippy from '../Base/BaseTippy'

export default {
  name: 'ValidationErrors',
  components: {
    BaseTippy,
    BaseIcon
  },
  props: {
    errors: {
      required: true
    }
  }
}
</script>

<style scoped>

</style>
